import { observer } from 'mobx-react'
import { GroupMemberPermission } from 'constants/group'
import { AuthRoleIdEnum, AuthRoleNameEnum } from 'constants/user'
import { getRoleNameFromId } from 'utils/auth/role'
import { useStores } from '../../hooks/useStores'

interface IAuthDisplayWrapperProps {
  allowedRoles: AuthRoleNameEnum[]
  allowedPermission?: GroupMemberPermission
  belongingGroupIds?: number[]
  children: React.ReactNode
}

const AuthDisplayWrapper = (props: IAuthDisplayWrapperProps) => {
  const { allowedRoles, children, allowedPermission, belongingGroupIds } = props
  const { userStore, authStore } = useStores()
  // Source the role from the cross-team max rank so a user who is e.g. ADMIN in
  // one team still sees admin-only chrome even before/without an active team
  // selection. BE remains the per-action authorization source of truth.
  const currentRoleId = authStore.maxRoleAcrossTeams
  const currentUserRole = getRoleNameFromId(currentRoleId)
  let isHidden = false

  if (!Array.isArray(allowedRoles) || allowedRoles.length === 0 || !currentUserRole) {
    isHidden = true
  } else {
    isHidden = !allowedRoles.some(role => currentUserRole.toLowerCase() === role.toLowerCase())
  }

  if (!isHidden && !!allowedPermission && currentRoleId === AuthRoleIdEnum.PLAYER) {
    const userGroupMembers = Array.isArray(userStore.currentUserGroupMembers)
      ? userStore.currentUserGroupMembers.filter(groupMember => belongingGroupIds?.includes(groupMember.groupId))
      : []
    if (userGroupMembers?.length === 0) {
      isHidden = true
    } else {
      isHidden =
        allowedPermission === GroupMemberPermission.EDITOR && !userGroupMembers.some(groupMember => !!groupMember.admin)
    }
  }

  return isHidden ? null : <>{children}</>
}

export default observer(AuthDisplayWrapper)
